import Comment from './Comment';
import React from 'react';


import { MDBCardHeader, } from 'mdbreact';

const CommentList = props => {
  return (

    <>
      <MDBCardHeader className="border-0 font-weight-bold" style={{ marginBottom: "20px" }}>
        <p className="text-right mr-4 mb-0">عدد التعليقات: {props.comments.length}</p>
      </MDBCardHeader>
      {
        props.comments.map(comment => {
          if (comment.hideComment) {
            return (<> </>)
          }
          return (
            <Comment
              comment={comment}
              currentUser={props.currentUser}
              slug={props.slug}
              key={comment.id} />
          );
        })
      }
    </>

  );
};

export default CommentList;
